import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useCurrency } from '../context/CurrencyContext';
import data from '../assets/dt-data/data-hotpick';
import { dtShopBrands, dtShopCategories } from '../assets/dt-data/data-dtshop';
import { allCoupons, couponCategories } from '../assets/dt-data/data-coupons';
import './Explore04.css';

function Explore04() {
    const navigate = useNavigate();
    const { addToCart } = useCart();
    const { currentCurrency } = useCurrency();
    const [addedToCart, setAddedToCart] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('ALL');
    const [popupCategory, setPopupCategory] = useState(null);
    const [showMaxSavings, setShowMaxSavings] = useState(false);
    const [showGamingCards, setShowGamingCards] = useState(false);
    const [visibleCoupons, setVisibleCoupons] = useState({});
    
    const COUPONS_PER_PAGE = 30;

    const heroBanners = [
        { id: 1, brand: 'RuPay', save: '₹200', off: '2% OFF', bgColor: '#B8D4E8', image: '/banners/rupay.webp' },
        { id: 2, brand: 'PlayStation', save: '₹40', off: '1% OFF', bgColor: '#A8BFDB', image: '/banners/playstation.webp' },
        { id: 3, brand: 'ROBLOX', save: '₹250', off: '5% OFF', bgColor: '#6BB8E8', image: '/banners/roblox.webp' },
        { id: 4, brand: 'Flipkart', save: '₹500', off: '10% OFF', bgColor: '#FFD8A8', image: '/banners/flipkart.webp' },
        { id: 5, brand: 'Myntra', save: '₹300', off: '6% OFF', bgColor: '#F4C2C2', image: '/banners/myntra.webp' },
        { id: 6, brand: 'Dominos', save: '₹150', off: '8% OFF', bgColor: '#FFB347', image: '/banners/dominos.webp' },
        { id: 7, brand: 'PhonePe', save: '₹120', off: '7% OFF', bgColor: '#FF9AA2', image: '/banners/phonepay.webp' },
        { id: 8, brand: 'Reliance', save: '₹400', off: '12% OFF', bgColor: '#D4A5E8', image: '/banners/reliance.webp' },
        { id: 9, brand: 'Cult.fit', save: '₹100', off: '5% OFF', bgColor: '#A8E6CF', image: '/banners/cult.fit.webp' },
        { id: 10, brand: 'Xbox', save: '₹350', off: '9% OFF', bgColor: '#B5E7A0', image: '/banners/xbox.webp' },
        { id: 11, brand: 'Valorant', save: '₹180', off: '4% OFF', bgColor: '#FFE5B4', image: '/banners/valorant.webp' },
        { id: 12, brand: 'Minecraft', save: '₹220', off: '6% OFF', bgColor: '#C9E4DE', image: '/banners/minecraft.webp' },
        { id: 13, brand: 'Unipin', save: '₹280', off: '7% OFF', bgColor: '#F0E68C', image: '/banners/unipin.webp' },
        { id: 14, brand: 'Uni', save: '₹160', off: '5% OFF', bgColor: '#DDA0DD', image: '/banners/uni.webp' },
        { id: 15, brand: 'Jewels', save: '₹450', off: '11% OFF', bgColor: '#F5DEB3', image: '/banners/jewels.webp' },
        { id: 16, brand: 'Dominos Special', save: '₹200', off: '8% OFF', bgColor: '#FFB6C1', image: '/banners/domino2.webp' },
        { id: 17, brand: 'RuPay Plus', save: '₹250', off: '6% OFF', bgColor: '#B0E0E6', image: '/banners/rupyay.webp' }
    ];

    const VISIBLE_SLIDES = 3;
    const [slideIndex, setSlideIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setSlideIndex((prev) => (prev + 1) % heroBanners.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [heroBanners.length]);

    const sideCards = [
        { id: 1, title: 'Save On', subtitle: 'Recharges', icon: '📱' },
        { id: 2, title: 'Max Savings', subtitle: 'Coupons', icon: '🎟️' },
        { id: 3, title: 'Gaming', subtitle: 'Gift Cards', icon: '🎮' }
    ];

    const quickCategories = [
        { id: 1, title: 'UNDER', subtitle: '₹99 STORE', bgColor: '#D94A3D', icon: '99', categoryKey: 'fashion', image: '/quick-banner/under_99_desktop.webp' },
        { id: 2, title: 'SUPER', subtitle: 'COINS', bgColor: '#2B7FBF', icon: '🪙', categoryKey: 'ecommerce', image: '/quick-banner/super_coins_desktop.webp' },
        { id: 3, title: 'EVERYDAY', subtitle: 'SAVINGS', bgColor: '#B04C87', icon: '💰', categoryKey: 'food', image: '/quick-banner/everyday_savings_desktop.webp' },
        { id: 4, title: 'MAX', subtitle: 'CASHBACK', bgColor: '#2B9B8F', icon: '💵', categoryKey: 'travel', image: '/quick-banner/max_cashback_desktop.webp' },
        { id: 5, title: 'ABOVE', subtitle: '₹1K STORE', bgColor: '#3B82C4', icon: '🎁', categoryKey: 'beauty', image: '/quick-banner/above_1k_store_desktop.webp' },
        { id: 6, title: 'NEW', subtitle: 'ARRIVALS', bgColor: '#E8804A', icon: '%', categoryKey: 'entertainment', image: '/quick-banner/new_arrivals_desktop.webp' }
    ];

    const bottomCategories = [
        { key: 'ALL', name: 'ALL', icon: '�' },
        ...dtShopCategories.map(c => ({ key: c.key, name: c.name.toUpperCase(), icon: c.icon }))
    ];

    const handleAddToCart = (item) => {
        addToCart(item);
        setAddedToCart(item.id);
        setTimeout(() => setAddedToCart(null), 2000);
    };

    const convertPrice = (priceString, rate) => {
        const numericPrice = parseFloat(priceString.replace(/[₹,]/g, ''));
        return (numericPrice * rate).toFixed(2);
    };

    const renderVoucherCard = (item, sectionKey) => {
        const isAdded = addedToCart === item.id;
        return (
            <div key={`${sectionKey}-${item.id}`} className="ex04-card">
                <div className="ex04-card-img">
                    <img src={item.img} alt={item.title} />
                </div>
                <div className="ex04-card-body">
                    <div className="ex04-card-price">
                        {currentCurrency.symbol}{convertPrice(item.price, currentCurrency.rate)}
                        <span className="saved"> Saved</span>
                    </div>
                    <button
                        onClick={() => handleAddToCart(item)}
                        className={`ex04-buy-btn ${isAdded ? 'added' : ''}`}
                    >
                        {isAdded ? '✓ Added' : 'Buy'}
                    </button>
                    <div className="ex04-compare">⇄ Compare</div>
                </div>
            </div>
        );
    };

    const handleViewMore = (categoryKey) => {
        setVisibleCoupons(prev => ({
            ...prev,
            [categoryKey]: (prev[categoryKey] || COUPONS_PER_PAGE) + COUPONS_PER_PAGE
        }));
    };

    const renderCouponCard = (coupon) => {
        const isAdded = addedToCart === coupon.id;
        const finalPrice = coupon.priceValue - coupon.savedValue;
        
        return (
            <div key={coupon.id} className="ex04-coupon-card">
                <div className="ex04-coupon-image">
                    <img 
                        src={coupon.image} 
                        alt={coupon.brand}
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                        }}
                    />
                    <div className="ex04-coupon-placeholder" style={{ display: 'none', background: `linear-gradient(135deg, ${coupon.gradient[0]}, ${coupon.gradient[1]})` }}>
                        <span>{coupon.initial}</span>
                    </div>
                    <div className="ex04-coupon-discount-badge">{coupon.discount}</div>
                </div>
                <div className="ex04-coupon-body">
                    <div className="ex04-coupon-brand">{coupon.brand}</div>
                    <div className="ex04-coupon-title">{coupon.voucher}</div>
                    <div className="ex04-coupon-pricing">
                        <div className="ex04-coupon-price">
                            <span className="original-price">{coupon.price}</span>
                            <span className="final-price">₹{finalPrice.toLocaleString('en-IN')}</span>
                        </div>
                        <div className="ex04-coupon-save">Save {coupon.saved}</div>
                    </div>
                    <button
                        onClick={() => {
                            const cartItem = {
                                ...coupon,
                                id: coupon.id,
                                title: coupon.voucher,
                                price: `₹${finalPrice.toLocaleString('en-IN')}`,
                                originalPrice: coupon.price,
                                discount: coupon.discount
                            };
                            addToCart(cartItem);
                            setAddedToCart(coupon.id);
                            setTimeout(() => setAddedToCart(null), 2000);
                        }}
                        className={`ex04-coupon-btn ${isAdded ? 'added' : ''}`}
                    >
                        {isAdded ? '✓ Added to Cart' : 'Add to Cart'}
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className="ex04-page">
            {/* Announcement Bar */}
            <div className="ex04-announce">
                <div className="ex04-announce-text">
                    🎉 Welcome to DT Wallet - Your Ultimate Voucher & Rewards Platform! Discover exclusive deals from top brands, save more on every purchase, and turn your everyday spending into real earnings. Shop smarter, earn rewards, and unlock premium vouchers across fashion, food, entertainment, travel & more! 🎁
                    &nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;
                    🎉 Welcome to DT Wallet - Your Ultimate Voucher & Rewards Platform! Discover exclusive deals from top brands, save more on every purchase, and turn your everyday spending into real earnings. Shop smarter, earn rewards, and unlock premium vouchers across fashion, food, entertainment, travel & more! 🎁
                </div>
            </div>

            {/* Hero Section */}
            <section className="ex04-hero">
                <div className="ex04-container">
                    <div className="ex04-hero-grid">
                        <div className="ex04-slider-viewport">
                            <div
                                className="ex04-slider-track"
                                style={{
                                    transform: `translateX(calc(-${slideIndex} * (100% / var(--visible-slides))))`
                                }}
                            >
                                {[...heroBanners, ...heroBanners.slice(0, VISIBLE_SLIDES)].map((banner, i) => (
                                    <div key={`${banner.id}-${i}`} className="ex04-slide">
                                        <div
                                            className="ex04-banner"
                                            style={{ background: banner.bgColor }}
                                        >
                                            <img 
                                                src={banner.image || '/placeholder-banner.png'} 
                                                alt={banner.brand}
                                                className="ex04-banner-image"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Dots */}
                            <div className="ex04-slider-dots">
                                {heroBanners.map((_, i) => (
                                    <button
                                        key={i}
                                        className={`ex04-slider-dot ${slideIndex === i ? 'active' : ''}`}
                                        onClick={() => setSlideIndex(i)}
                                        aria-label={`Go to slide ${i + 1}`}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className="ex04-side-stack">
                            {sideCards.map(card => (
                                <div 
                                    key={card.id} 
                                    className="ex04-side-card"
                                    onClick={() => {
                                        if (card.id === 2) {
                                            setShowMaxSavings(true);
                                        } else if (card.id === 3) {
                                            setShowGamingCards(true);
                                        } else {
                                            navigate('/login');
                                        }
                                    }}
                                >
                                    <div className="ex04-side-icon">{card.icon}</div>
                                    <div>
                                        <div className="ex04-side-title">{card.title}</div>
                                        <div className="ex04-side-subtitle">{card.subtitle}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Info Bar */}
            <section className="ex04-info">
                <div className="ex04-container">
                    <div className="ex04-info-row">
                        <div className="ex04-info-item">
                            <span className="dot">✓</span>
                            <span>Trusted by thousands across the world who rely on us for seamless experiences</span>
                        </div>
                        <div className="ex04-info-item">
                            <span className="dot">+</span>
                            <span>Backed by transparent pricing and real, verifiable savings with no hidden surprises</span>
                        </div>
                        <div className="ex04-info-item">
                            <span className="dot">🛡️</span>
                            <span>Safe, secure, and reliable coupons you can trust</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Quick Categories */}
            <section className="ex04-quick">
                <div className="ex04-container">
                    <h3 className="ex04-section-label">QUICK CATEGORIES</h3>
                    <div className="ex04-quick-grid">
                        {quickCategories.map(cat => (
                            <div
                                key={cat.id}
                                className="ex04-quick-card"
                                style={{ 
                                    backgroundImage: `url(${cat.image})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}
                                onClick={() => setPopupCategory(cat.categoryKey)}
                            >
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Category Tabs */}
            <section className="ex04-tabs">
                <div className="ex04-container">
                    <div className="ex04-tabs-row">
                        <button className="ex04-cat-btn">
                            <span style={{ fontSize: '16px' }}>☰</span>
                            CATEGORIES ▾
                        </button>
                        {bottomCategories.map((cat) => {
                            const isActive = selectedCategory === cat.key;
                            return (
                                <button
                                    key={cat.key}
                                    onClick={() => setSelectedCategory(cat.key)}
                                    className={`ex04-tab ${isActive ? 'active' : ''}`}
                                >
                                    <span className="tab-icon">{cat.icon}</span>
                                    {cat.name}
                                </button>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* Coupon Sections grouped by category */}
            {couponCategories
                .filter(cat => selectedCategory === 'ALL' || selectedCategory === cat.key)
                .map(cat => {
                    const coupons = allCoupons.filter(c => c.categoryKey === cat.key);
                    if (coupons.length === 0) return null;
                    
                    const visibleCount = visibleCoupons[cat.key] || COUPONS_PER_PAGE;
                    const displayedCoupons = coupons.slice(0, visibleCount);
                    const hasMore = visibleCount < coupons.length;
                    
                    return (
                        <section key={cat.key} className="ex04-section">
                            <div className="ex04-container">
                                <div className="ex04-section-header">
                                    <div className="line"></div>
                                    <h3>
                                        <span style={{ marginRight: 8 }}>{cat.icon}</span>
                                        {cat.name.toUpperCase()}
                                        <span style={{ fontSize: '14px', fontWeight: 400, marginLeft: 12, color: '#888' }}>
                                            ({displayedCoupons.length} of {coupons.length})
                                        </span>
                                    </h3>
                                    <div className="line"></div>
                                </div>
                                <div className="ex04-coupon-grid">
                                    {displayedCoupons.map(renderCouponCard)}
                                </div>
                                {hasMore && (
                                    <div className="ex04-view-more-container">
                                        <button 
                                            className="ex04-view-more-btn"
                                            onClick={() => handleViewMore(cat.key)}
                                        >
                                            View More ({coupons.length - visibleCount} remaining)
                                        </button>
                                    </div>
                                )}
                            </div>
                        </section>
                    );
                })}

            {/* Category Popup */}
            {popupCategory && (
                <div className="ex04-popup-overlay" onClick={() => setPopupCategory(null)}>
                    <div className="ex04-popup" onClick={(e) => e.stopPropagation()}>
                        <button className="ex04-popup-close" onClick={() => setPopupCategory(null)}>✕</button>
                        <div className="ex04-popup-header">
                            <h2>
                                {couponCategories.find(c => c.key === popupCategory)?.icon} {' '}
                                {couponCategories.find(c => c.key === popupCategory)?.name}
                            </h2>
                        </div>
                        <div className="ex04-popup-content">
                            <div className="ex04-coupon-grid">
                                {allCoupons
                                    .filter(c => c.categoryKey === popupCategory)
                                    .map(renderCouponCard)}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Max Savings Popup */}
            {showMaxSavings && (
                <div className="ex04-popup-overlay" onClick={() => setShowMaxSavings(false)}>
                    <div className="ex04-popup" onClick={(e) => e.stopPropagation()}>
                        <button className="ex04-popup-close" onClick={() => setShowMaxSavings(false)}>✕</button>
                        <div className="ex04-popup-header">
                            <h2>
                                🎟️ Max Savings - Highest Discount Coupons
                            </h2>
                            <p style={{ margin: '8px 0 0', fontSize: '14px', color: '#888' }}>
                                Coupons sorted by highest discount percentage
                            </p>
                        </div>
                        <div className="ex04-popup-content">
                            <div className="ex04-coupon-grid">
                                {allCoupons
                                    .sort((a, b) => b.discountRate - a.discountRate)
                                    .map(renderCouponCard)}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Gaming Gift Cards Popup */}
            {showGamingCards && (
                <div className="ex04-popup-overlay" onClick={() => setShowGamingCards(false)}>
                    <div className="ex04-popup" onClick={(e) => e.stopPropagation()}>
                        <button className="ex04-popup-close" onClick={() => setShowGamingCards(false)}>✕</button>
                        <div className="ex04-popup-header">
                            <h2>
                                🎮 Gaming Gift Cards
                            </h2>
                            <p style={{ margin: '8px 0 0', fontSize: '14px', color: '#888' }}>
                                PlayStation, Xbox, Steam, Google Play & more gaming vouchers
                            </p>
                        </div>
                        <div className="ex04-popup-content">
                            <div className="ex04-coupon-grid">
                                {allCoupons
                                    .filter(c => c.categoryKey === 'entertainment')
                                    .map(renderCouponCard)}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Footer Banner */}
            <section className="ex04-footer-banner">
                <img 
                    src="/footer-banner.jpg" 
                    alt="Special Offers" 
                    className="ex04-footer-banner-img"
                />
            </section>
        </div>
    );
}

export default Explore04;
